import { Component, inject } from '@angular/core';
import { UnitOfMeasureService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  UnitOfMeasureCreateDto,
  UnitOfMeasureDto,
  UnitOfMeasureExcelDownloadDto,
  UnitOfMeasureUpdateDto,
} from '../proxy/general/dtos/unit-of-measure';
import { UNITOFMEASURE_CONFIG, UNITOFMEASURE_FIELDS } from './unit-of-measure.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-unit-of-measure',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, UnitOfMeasureService, ConfirmationService],
  templateUrl: './unit-of-measure.html',
  styleUrl: './unit-of-measure.scss',
})
export class UnitOfMeasure extends BaseCrudComponent<
  UnitOfMeasureDto,
  UnitOfMeasureCreateDto,
  UnitOfMeasureUpdateDto,
  UnitOfMeasureExcelDownloadDto
> {
  service = inject(UnitOfMeasureService);
  config = UNITOFMEASURE_CONFIG;
  fields = UNITOFMEASURE_FIELDS;

  protected prepareUpdateDto(data: any, selected: UnitOfMeasureDto): UnitOfMeasureUpdateDto {
    return {
      name: data.name,
      code: data.code,
      sapCode: data.sapCode,
      iso: data.iso,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'UnitOfMeasure';
  }
}
